import React from 'react';
import { AdminFeRoleMasterComponent } from './adminACJSLegalFEMgmt';

export function AdminFeAcMgmt() {
  return (
    <AdminFeRoleMasterComponent
      title="FE AC Master"
      apiEndpoint="fe-ac"
      roleFieldName="ac"
      roleLabel="AC"
    />
  );
}


export function AdminFETahsildarMgmt(){
    return (
        <AdminFeRoleMasterComponent
                    title="FE Tahsildar Master"
                    apiEndpoint="fe-tahsildar"
                    roleFieldName="tahsildar"
                    roleLabel="Tahsildar"
                  />
    )
}


export function AdminFeLegalMgmt(){
    return(
        <AdminFeRoleMasterComponent
                    title="FE Legal Master"
                    apiEndpoint="fe-legal"
                    roleFieldName="legal"
                    roleLabel="Legal"
                  />
    )
}


export function AdminFeJsmgmt(){
    return(
         <AdminFeRoleMasterComponent
            title="FE JS Master"
            apiEndpoint="fe-js"
            roleFieldName="js"
            roleLabel="JS"
          />
    )
}